import styled from "styled-components";

const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
`;

export default Container;
